import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useEffect } from "react";

export function ProtectRoute(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const { isAuth } = useAuth();

    useEffect(() => {
        if (location) {
            if (location.pathname === props.path && isAuth === false) {
                navigate('/login');
            }
        }
    }, [location, isAuth]);

    return <></>
}